module.exports = __webpack_public_path__ + "static/media/covid.d7265326.png";